import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import {
  getSharedAssetContainerStyle,
  getSharedMultiSelectingCellStyles,
} from './../shared-cell-style';

export const useImageAssetsGridCellStyle = makeStyles({
  imageAssetsGridCellContainer: {
    ...getSharedAssetContainerStyle(),

    // the 'Updating' label animation
    '& .updating-label-icon-and-text': {
      display: 'flex',
      backgroundColor: tokens.colorNeutralBackgroundStatic,

      '& .label-icon': {
        animationName: [{
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        }],
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
      },
    },
  },

  imageCellLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    left: '12px',
    bottom: '8px',
    zIndex: 1,

    '& .label-icon-and-text.created-with-ai-label': {
      display: 'flex',
      ...shorthands.padding(0),
      ...shorthands.margin(0),
      marginRight: '6px',
      height: '24px',
      backgroundColor: '#FFFFFFBB',

      '& .label-icon': {
        ...shorthands.margin(0),
      },
    },

    '& .label-icon-and-text.image-source-label': {
      ...shorthands.padding('2px', '4px'),
      backgroundColor: '#616161',
    },
  },

  // only show checkbox on overlay if it is NOT in multi-selecting mode
  ...getSharedMultiSelectingCellStyles(),

});
